<template>
  <div
    class="main-header animated bounceInRight"
    :style="{ backgroundImage: `url(${hOp.img})` }"
    :key="sn"
  >
    <div class="content-header" @dblclick="screenfullToggle">
      <span :class="hOp.titleClass || 'header-text1'">
        {{ title }}
      </span>
    </div>
    <div class="content-box">
      <div class="header-weather">
        <span v-if="hOp.name && currentChooseDevice">
          <span v-if="authMenu['010219']">{{ currentChooseDevice.name }}</span>
          <span v-else>{{ currentChooseDevice.name }}({{ currentChooseDevice.sn }})</span>
        </span>
        <span v-if="hOp.weather">{{ weatherData.mods | weatherText }}</span>
        <span v-if="!isEmpty(hOp['pm2.5'])">{{ currentDeviceDetail.mods | pm25Text }}</span>
        <span v-if="!isEmpty(hOp.pm10)">{{ currentDeviceDetail.mods | pm10Text }}</span>
        <span v-if="hOp.o2">{{ weatherData.mods | o2Text }}</span>
        <span v-if="hOp.temperature">{{ currentDeviceDetail.mods | temperature }}</span>
        <span v-if="hOp.humidity">{{ currentDeviceDetail.mods | humidity }}</span>
        <span v-if="hOp.state">
          {{ $t('设备状态') }}:&nbsp;
          <em :style="{ color: runstateOption.c }">{{ runstateOption.t }}</em>
        </span>
      </div>

      <div class="header-tab" v-if="hOp.menu && !isHisDetail">
        <el-menu
          mode="horizontal"
          background-color="transparent"
          text-color="var(--main-header-tab-color)"
          active-text-color="var(--main-header-tab-active-color)"
          @select="selectHandler"
        >
          <template v-for="(m, i) in headerTabs">
            <!-- v-if="!m.code || authMenu[m.code]" -->
            <el-menu-item
              :key="i"
              :index="i + ''"
              :disabled="isDisabled(m.disabled)"
              class="pro-menu"
            >
              <span v-if="!m.children">{{ $t(m.title) }}</span>

              <el-dropdown v-else size="small">
                <div class="dropdown-btn">
                  <span>{{ $t(m.title) }}</span>
                  <i v-if="m.suffixIcon" :class="m.suffixIcon"></i>
                </div>

                <el-dropdown-menu slot="dropdown">
                  <template v-for="item in m.children">
                    <el-dropdown-item
                      v-if="!item.code || authMenu[item.code]"
                      :key="item.title"
                      :disabled="isDisabled(item.disabled)"
                      @click.native="dropdownSelectHandler(item)"
                    >
                      {{ $t(item.title) }}
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
          </template>
          <el-menu-item class="pro-menu" v-if="has4G || hasBattery">
            <span v-if="has4G" class="enable4g" :class="{ disable4g: disable4G }">4G</span>
            <BatteryIcon v-if="hasBattery" :surplus="surplus" />
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <bg-state :sn="sn" :visible.sync="bgStateVisible" :device-type="deviceType"></bg-state>
    <params-dialog :sn="sn" :deviceType="deviceType" :visible.sync="paramVisible"></params-dialog>
    <el-dialog
      v-if="modelVisible"
      :title="$t('预测分析模型')"
      :visible="true"
      :append-to-body="true"
      width="70%"
      top="5vh"
      :before-close="modelHandler"
      custom-class="map-dialog"
    >
      <div class="model-map">
        <PuffMap @closeLoading="closeLoading" v-if="!isLocal" />
        <LocalPuffMap v-else @closeLoading="closeLoading" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mixin from './mixin';
import screenfull from 'screenfull';
import { isLocal } from '@/utils/utils';
import { isEmpty } from '@/utils/is';

export default {
  name: 'MainHeader',
  mixins: [mixin],
  components: {
    BgState: () => import('../components/bg-state.vue'),
    ParamsDialog: () => import('@/components/deviceParamDialog'),
    PuffMap: () => import('./puff-map'),
    LocalPuffMap: () => import('./local-puff-map'),
    BatteryIcon: () => import('../components/battery-icon.vue')
  },
  sockets: {
    '/socket/detail'(data) {
      if (this.isHisDetail) return;
      if (this.$route.params.sn !== data.sn) return;
      if (!data || !data.mods || !data.mods.sysMod) return;
      const sysMod = data.mods.sysMod;
      this.hasBattery = sysMod.batteryExists === 1;
      this.surplus = sysMod.batteryCapacity;
      this.has4G = sysMod.mobileExists === 1;
      this.disable4G = sysMod.mobileEnableState === 0;
    }
  },
  data() {
    return {
      hasBattery: false,
      surplus: 100,
      has4G: false,
      disable4G: false,
      isLocal: isLocal()
    };
  },
  computed: {
    hOp() {
      return this.$route.meta.headerOptions;
    },
    headerTabs() {
      if (window.name) return [];

      const dict = {
        'zh-CN': this.isMobile ? 4 : 5,
        ar: this.isMobile ? 3 : 5,
        fr: 2,
        default: 3
      };

      const num = dict[this.$i18n.locale] || dict.default;

      const commonMenu = this.commonMenu.filter(e => {
        return !e.excludes?.includes(this.deviceType);
      });

      let menus = commonMenu
        .concat(this.menuMap[this.hOp.menu] || [])
        .sort((a, b) => a.sort - b.sort)
        .filter(e => {
          if (!e.code) return true;

          return this.authMenu[e.code];
        });

      if (menus.length > num + 1) {
        menus = menus.slice(0, num).concat({
          title: '更多',
          suffixIcon: 'el-icon-caret-bottom',
          sort: 99,
          children: menus.slice(num)
        });
      }

      return menus;
    },
    isHisDetail() {
      // 是否为历史详情页面
      return !!this.$route.params.eventId;
    },
    title() {
      return (
        this.hOp.title ||
        this?.currentChooseDevice?.deviceTypeName ||
        this.singleDeviceDetail?.deviceTypeName ||
        '设备监控'
      );
    }
  },
  methods: {
    isEmpty,
    screenfullToggle() {
      if (screenfull.isEnabled) {
        if (screenfull.isFullscreen) {
          screenfull.exit();
        } else {
          screenfull.request(document.getElementById('appContent'));
        }
      }
    }
  }
};
</script>
<style lang="scss">
.main-header {
  height: var(--main-header-height);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;

  .disable4g {
    color: #898989;
  }
  .enable4g {
    color: white;
  }

  .content-header {
    position: absolute;
    top: var(--main-header-title-top);
    left: 50%;
    transform: translateX(-50%);
    font-size: var(--main-header-title-fs);
    font-family: SimHei;
    font-weight: bold;
    letter-spacing: var(--main-header-title-spacing);
    cursor: pointer;
    .header-text1 {
      user-select: none;
      background-image: var(--main-header-title-color);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }
    .header-text2 {
      background-image: linear-gradient(#efeff0, #898989);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }
  }

  .content-box {
    height: var(--main-header-box-height);
    line-height: var(--main-header-box-height);
    padding: var(--main-header-box-padding);
    display: flex;
    justify-content: space-between;
  }

  .header-weather {
    color: var(--main-header-weather-color);
    span {
      margin-right: var(--main-header-box-gap);
      &:first-child {
        font-size: var(--main-header-box-fs);
        font-weight: bold;
      }
    }
  }

  .header-tab {
    font-size: 18px;
    color: var(--main-header-tab-color);
    .el-menu {
      border: none;
      .is-active {
        border-bottom: none;
      }
    }
    .pro-menu {
      height: 34px;
      line-height: 1;
      padding: 0 8px;

      display: flex;
      align-items: center;
      border: unset;

      background-color: transparent !important;

      &:hover:not(.is-disabled) {
        color: var(--main-header-tab-hover-color) !important;
        background-color: var(--main-header-tab-hover-bg) !important;
      }

      .el-dropdown {
        color: inherit;

        .dropdown-btn {
          [class^='el-icon-'] {
            color: inherit;

            margin-right: 0px;
            width: 14px;
            text-align: center;
            font-size: 14px;
            vertical-align: baseline;
          }
        }
      }
    }
  }
}
</style>
